// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"bdf96c03","121":"797d8ee1","154":"e62bf229","928":"95b1bc70","965":"79c33c9e"}[chunkId] + ".chunk.js";
};